import React, { Component } from 'react';
import {Card, Table, Modal, Button, Input, Form, InputNumber, Select, Pagination} from 'antd';
import {
    linkSourceAdd,
    linkSourceDelete,
    linkSourceListInitDataSource,
    linkSourceUpdate,
    linkSourceGetById
} from "../../../actions/linkSourceList";
import {imageSourceGetById} from "../../../actions/imageSourceList";
import {HEADER_HEIGHT} from "../../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../components/baseTable/BaseTable";
import BaseComponent from "../../../base/BaseComponent";
import $Jq from "jquery";

const start = 1;//从1第一页开始
const size = 10;//每页10条

/** 列表 */
class LinkSourceList extends BaseComponent {
	columns = [
		{
    		title: '链接标题',
		    dataIndex: 'linkTitle',
            key: 'linkTitle',
            ellipsis: true,
            render: (text, record) => (
                <a onClick={()=>{
                    if(this.state.disable == 1){
                        return false
                    }else {
                        this.updateLinkSource(record)
                    }
                }}>{text}</a>
            )
		},
		{
			title: '链接地址',
			dataIndex: 'linkAddress',
			key: 'linkAddress',
            width:394,
            render: (text, record) => (
                <div  title={text}
                      style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                      }}>{text}</div>
            ),
		},
		{
			title: '链接说明',
			dataIndex: 'instructions',
			key: 'instructions',
            width:139,
            render: (text, record) => (
                <div  title={text}
                      style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                      }}>{text}</div>
            ),
		},
		{
			title: '链接类型',
			dataIndex: 'linkType',
			key: 'linkType',
            render: (text, record) => {
			    let value = "";
                if(text === 1){
                    value = "新窗口打开";
                }else {
                    value = "当前窗口打开";
                }
                return value;
            },
            width: 152
		},
		{
			title: '显示次序',
			dataIndex: 'showOrder',
			key: 'showOrder',
            width: 129
		},
		{
			title: '操作',
			key: 'action',
			render: (text, record) => (
				this.state.disable == 1 ? "" : <div style={{marginLeft:'-17px'}}>
                    <Button type="link" onClick={()=>this.updateLinkSource(record)}>修改</Button>
                    <Button type="link"  onClick={()=>this.deleteLinkSource([record])}>删除</Button>
                </div>
			),
            width: 169,
		}
	];
    constructor(props) {
        super(props);
        this.state = {
            start : start,
            size : size,
            total: 0,
            selectedRows:[],
            data: [],
            params:this.props.match.params,
            disable:1
        }
    }

    initDataSource = (page, pageSize) => this.paginationOnChange(page, pageSize);

    paginationOnChange(page, pageSize){
        let body={
            page,
            size: pageSize,
            mediaId: this.state.params.mediaId,
            contentId: this.state.params.contentId
        };
        linkSourceListInitDataSource(body, (res)=>{
            this.setState(prevState => {
                return {
                    ...prevState,
                    start : page,
                    size : pageSize,
                    total: res.count,
                    data: (()=>{
                        for(let i = 0; res.data && i < res.data.length; i++){
                            //这个key是react的item必须的，如果没有这会按照索引来。但是复选框就会出问题了。
                            //当选择了某个选项，再翻页后，会将新页码中的数据也选中
                            if(!res.data[i].key){
                                res.data[i].key = res.data[i].id;
                            }
                        }
                        return res.data;
                    })(),
                    selectedRows:[]
                }
            })
        });
    }

    componentDidMount() {
        this.initDataSource(this.state.start, this.state.size);
        this.getMediaById()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.state.params=nextProps.match.params
        this.initDataSource(this.state.start, this.state.size);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        $Jq('.ant-pagination-options-quick-jumper').find("input").val("");
    }

    onSelect = (record, selected, selectedRows, nativeEvent)=>{
        this.setState({
            selectedRows: selectedRows
        })
    };

    onSelectAll = (selected, selectedRows, changeRows) => {
        this.setState({
            selectedRows: selectedRows
        })
    };

//修改按钮接口
    updateLinkSource = (linkSource) => {
        let fieldData = {
            ...linkSource,
            ...this.state.params
        };

        this.LinkSourceModal.showModal("修改", fieldData,linkSourceGetById,linkSourceUpdate, ()=>{
            this.paginationOnChange(this.state.start, this.state.size);
        });
    };
    //新增按钮功能
    addLinkSource = () => {
        this.LinkSourceModal.showModal("新增", this.state.params, null,linkSourceAdd, ()=>{
            this.paginationOnChange(this.state.start, this.state.size);
        });
    };

    deleteLinkSource = (selectedRows) => {
        let that = this;
        if(!selectedRows || selectedRows.length === 0){
            Modal.error({
                title: '请选择要删除的项',
                okText:"确定"
            });
            return;
        }
        Modal.confirm({
            title: '删除链接源',
            content: '删除后无法恢复，确定删除？',
            okText: '确认',
            cancelText: '取消',
            onOk: ()=>{
                let ids = [];
                for(let i = 0; selectedRows && i < selectedRows.length; i ++){
                    let id = selectedRows[i].id;
                    ids.push(id);
                }
                if(ids && ids.length === 1){
                    linkSourceDelete({id:ids[0]},()=>{
                        //如果当前页不是第一页且是最后一页，并且这页的数据和删除的数据长度一样。
                        //那么页码就得往前翻一页
                        if(ids.length === that.state.data.length
                            && Math.ceil(that.state.total / that.state.size) === this.state.start
                            && this.state.start != 1){
                            this.paginationOnChange(that.state.start - 1, that.state.size);
                        }else{
                            this.paginationOnChange(that.state.start, that.state.size);
                        }
                    });
                    that.setState(prevState =>{
                        let tempSelectedRows = [];
                        for(let j = 0; prevState.selectedRows && j < prevState.selectedRows.length; j ++){
                            let row = prevState.selectedRows[j];
                            if(row.id !== ids[0]){
                                tempSelectedRows.push(row);
                            }
                        }
                        return {
                            ...prevState,
                            selectedRows:tempSelectedRows
                        };
                    })
                }else if(ids && ids.length > 1){
                    // linkSourceDeletes(ids,()=>{
                    //     //如果当前页不是第一页且是最后一页，并且这页的数据和删除的数据长度一样。
                    //     //那么页码就得往前翻一页
                    //     if(ids.length === that.state.data.length
                    //         && Math.ceil(that.state.total / that.state.size) === this.state.start
                    //         && this.state.start != 1){
                    //         this.paginationOnChange(that.state.start - 1, that.state.size);
                    //     }else{
                    //         this.paginationOnChange(that.state.start, that.state.size);
                    //     }
                    // });
                    that.setState({
                        selectedRows:[]
                    });
                }
            }
        });
    };

    //获取选中的项，用于回显
    getSelectedRowKeys = ()=>{
        let selectedRowKeys = [];
        for(let j = 0; this.state.selectedRows && j < this.state.selectedRows.length; j ++){
            let row = this.state.selectedRows[j];
            selectedRowKeys.push(row.key);
        }
        return selectedRowKeys;
    };

    render() {
        const margin = 15;
        const type = "checkbox";//也可以是radio
        let pagination = {
            onChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            onShowSizeChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            defaultCurrent: 1,
            defaultPageSize: 10,
            current: this.state.start,
            pageSize: this.state.size,
            total: this.state.total,
            showQuickJumper: true, //快速跳转至某一页
            showSizeChanger: true,	//是否可以改变 pageSize
        };
        let selectedRowKeys = this.getSelectedRowKeys();
        let height = window.innerHeight - HEADER_HEIGHT - 15 - 15;
        return (
            <div style={{backgroundColor: 'white',
                height: height,
                margin: 'auto',
                marginTop: 15,
                marginLeft:15,
                borderRadius: '5px',
                overflow: 'hidden',
            }}>
                {/*新增按钮*/}
                {this.renderAddBtn()}
                {/*<Button type="danger" style={{marginLeft:"10px",marginBottom:"20px"}} onClick={()=>this.deleteImageSource(this.state.selectedRows)}>批量删除</Button>*/}
                {/*表格*/}
                {this.renderTable()}
                {/*分页栏*/}
                {this.renderPage()}
                <LinkSourceModal {...this.props.match.params} ref={LinkSourceModal=>this.LinkSourceModal = LinkSourceModal} />
            </div>
            // <Card title={<span style={{fontSize: "14px"}}>链接源列表</span>} style={{ width: "calc(100% - "+margin*2+"px)", margin: margin + "px"}}>
            //     <Button type="primary" style={{marginBottom:"20px"}} onClick={()=>this.addLinkSource()}>新增</Button>
            //     {/*<Button type="danger" style={{marginLeft:"10px",marginBottom:"20px"}} onClick={()=>this.deleteLinkSource(this.state.selectedRows)}>批量删除</Button>*/}
            //     <LinkSourceModal ref={"linkSourceModal"} />
            //     <Table columns={this.columns} dataSource={this.state.data} pagination={pagination}
            //            /*rowSelection={{
            //                selectedRowKeys: selectedRowKeys,
            //                onSelect: this.onSelect,
            //                onSelectAll: this.onSelectAll,
            //                type: type
            //            }}*/
            //            scroll={{x:window.document.body.clientWidth - 420, y:this.state.tableHeight - 355}}
            //            bordered={true}//是否展示外边框和列边框
            //            size={"small"}/>
            // </Card>
        );
    }
    //分页器搜索功能
    onChange = (type, e) => {
        switch (type) {
            case 'page':
                this.state.start = e;
                break;
            case 'size':
                this.state.size = e;
                this.state.start = 1;
                break;
        }
        this.getImageData()
    }
    //查看当前页面是否禁用状态
    getMediaById = () => {
        this.request({
            url: "/cm-sites-pms/media/getById",
            body: {
                mediaId:this.state.params.mediaId
            },
            callBack: (res) => {
                let disable = 0;
                if(res) {
                    disable = res.disable
                }
                this.setState({disable});
                console.log(this.state.disable,"333")
            }
        })
    };
    //分页栏
    renderPage = () => {
        let {total, start, size, data} = this.state;
        if(!total) return <div style={{height:81}}></div>;
        if(!(data&&data.length>0) && start>1) {
            this.onChange('page', --start, size)
        }
        return (
            <div style={{
                display: "flex",
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderTop: '1px solid #f6f8fd',
                padding: '24px 32px',
            }}
            >
                <Pagination
                    size="middle"
                    total={total}
                    showTotal={(total) => `共有${total}条数据`}
                    showSizeChanger
                    showQuickJumper
                    current={start}
                    pageSize={size}
                    onChange={(page, pageSize) => {
                        this.onChange('page', page, pageSize)
                    }} //页码改变时回调
                    onShowSizeChange={(page, pageSize) => {
                        this.onChange('size', page, pageSize)
                    }} //每页条数改变回调
                />
            </div>
        )
    }
    //新增按钮
    renderAddBtn=()=>{
        return(
            this.state.disable == 1 ? "" : <div style={{paddingLeft: "32px", paddingTop:"24px"}}>
                <Button type="primary" onClick={()=>this.addLinkSource()}>新增</Button>
            </div>
        )
    }
    //表格
    renderTable=()=>{
        let tableHeight = window.innerHeight - HEADER_HEIGHT - 96-80 - 15 - 15 - 15;
        return(
            <div style={{paddingLeft: "32px", paddingTop:"24px",paddingRight:32}}>
                <Scrollbars autoHeight autoHeightMax={tableHeight} autoHide>
                    <BaseTable columns={this.columns} dataSource={this.state.data}/>
                </Scrollbars>
            </div>
        )
    }
}

/** 弹窗 */
class LinkSourceModal extends React.Component{

    state = {
        title: "信息",
        visible: false,
        fieldData: {},
        confirmLoading: false,
    };

    closeBallBack(){

    };
    okCallBack(){

    };

    showModal = (title, fieldData, showCallBack,okCallBack, closeCallBack) => {
        if (showCallBack) {
            showCallBack({id: fieldData.id}, (res) => {
                this.setState({
                    title: title,
                    visible: true,
                    fieldData: (()=>{
                        if(!res){
                            return null;
                        }
                        let value = {};
                        for(let attr in res){
                            value[attr] = {
                                value: res[attr]
                            }
                        }
                        return value;
                    })()
                });
            });
        }else {
            this.setState({
                title: title,
                visible: true,
            })
        }
        this.okCallBack = okCallBack;
        this.closeBallBack = closeCallBack;
    };

    handleOk = (e) => {
        this.setState({
            confirmLoading: true,
        });

        let that = this;
        let wrappedLinkSourceModalForm = this.refs.wrappedLinkSourceModalForm;//通过refs属性可以获得对话框内form对象
        wrappedLinkSourceModalForm.validateFields((err, values) => {
            let body={...values,...this.props};
            console.log(body)
            if(!err){
                if(!values.showOrder){
                    values.showOrder = 1;
                }
                if(!values.instructions){
                    values.instructions = "";
                }
                that.okCallBack(body, function(){
                    that.setState({
                        visible: false,
                        confirmLoading: false,
                    });
                    wrappedLinkSourceModalForm.resetFields();
                    if(that.closeBallBack){
                        that.closeBallBack();
                    }
                });
            }else{
                this.setState({
                    confirmLoading: false,
                });
            }
        });
    };

    handleCancel = () => {
        let wrappedLinkSourceModalForm = this.refs.wrappedLinkSourceModalForm;
        wrappedLinkSourceModalForm.resetFields();
        this.setState({
            visible: false,
        });
    };

    render() {
        const { visible, confirmLoading } = this.state;
        return (
            <Modal
                title={this.state.title}
                visible={visible}
                onOk={this.handleOk}
                okText={"确定"}
                maskClosable={true}
                cancelText={"取消"}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
                width={650}
            >
                <WrappedLinkSourceModalForm fieldData={this.state.fieldData} ref={"wrappedLinkSourceModalForm"} />
            </Modal>
        );
    }
}

const { Option } = Select;
/** 表单 */
class LinkSourceModalForm extends React.Component{

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    fieldData;

    initFields(props) {
        const { fieldData } = props;
        const { setFields } = props.form;
        if(fieldData && this.fieldData !== fieldData){
            this.fieldData = fieldData;
            setFields(fieldData);
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        return (
            <Form {...formItemLayout}>
                {getFieldDecorator('id',{
                    initialValue:0
                })(
                    <Input type={"hidden"} />
                )}
                {getFieldDecorator('mediaCode')(
                    <Input type={"hidden"} />
                )}
                {getFieldDecorator('treeId')(
                    <Input type={"hidden"} />
                )}
                {getFieldDecorator('treeContentId')(
                    <Input type={"hidden"} />
                )}
                {getFieldDecorator('wbLinkId',{
                    initialValue:0
                })(
                    <Input type={"hidden"} />
                )}
					<Form.Item label="链接标题">
                    {getFieldDecorator('linkTitle', {
                        rules: [{ required: true, message: '请输入链接标题!' }],
                    })(
                        <Input placeholder="请输入链接标题" />
                    )}
                </Form.Item>
					<Form.Item label="链接地址">
                    {getFieldDecorator('linkAddress',{
                        rules: [{required: true, message: '请输入正确的链接地址!' ,pattern : new RegExp(/http[s]{0,1}:\/\/([\w.]+\/?)\S*/)}],
                    })(
                        <Input placeholder="请输入链接地址" />
                    )}
                </Form.Item>
					<Form.Item label="链接说明">
                    {getFieldDecorator('instructions',{
                        rules: [{type:'string',max:120,message: '说明文字不能超过120字!'}]
                    })(
                        <Input placeholder="请输入链接说明" />
                    )}
                </Form.Item>
					<Form.Item label="链接类型">
                        {getFieldDecorator('linkType',{
                            initialValue : 1,
                        })(
                            <Select>
                                <Option value={1}>新窗口打开</Option>
                                <Option value={0}>当前窗口打开</Option>
                            </Select>
                        )}
                </Form.Item>
					<Form.Item label="显示次序">
                        {getFieldDecorator('showOrder',{initialValue:1})(
                            <InputNumber min={1} />
                        )}
                        <span style={{marginLeft:"5px"}}>本链接在页面元素中显示的次序</span>
                </Form.Item>
            </Form>
        );
    }
}

const WrappedLinkSourceModalForm = Form.create()(LinkSourceModalForm);

export default LinkSourceList;